import { BillingPeriod } from '../../../../../../enums/billing-period.enum';

export enum WorkflowType {
  /** When a customer that is trying to upgrade their plan by themselves through the app */
  InAppPlanPurchase = 'InAppPlanPurchase',
  /** When a sales person is trying to upgrade a customer's plan through the back office */
  BackOfficeSales = 'BackOfficeSales',
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type InAppPlanPurchaseWorkflowData = {};

export type BackOfficeSalesWorkflowData = {
  userEmailToInvite?: string;
  monthlyCreditsToSet?: number;
};

export type WorkflowData = InAppPlanPurchaseWorkflowData | BackOfficeSalesWorkflowData;

export type CreateCheckoutSessionRequest = {
  accountId?: string;
  userId?: string;
  callbackUrl: string;
  planDefinitionId?: string;
  billingPeriod?: BillingPeriod;
  quantity?: number;
  customUnitPrice?: number;
  allowAdjustableQuantity?: boolean;
  workflowType?: WorkflowType;
  workflowData?: WorkflowData;
};
